import { render, staticRenderFns } from "./set-info.vue?vue&type=template&id=a531c206&scoped=true&"
import script from "./set-info.vue?vue&type=script&lang=js&"
export * from "./set-info.vue?vue&type=script&lang=js&"
import style0 from "./set-info.vue?vue&type=style&index=0&id=a531c206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a531c206",
  null
  
)

export default component.exports